import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { RoleService } from '../services/role.service';
import {
  fetchRoleList,
  loadedRoleList,
  failedRoleList,
  updateRoleListFilter,
} from './role-list.actions';
import { selectRoleListFilter } from './role-list.selector';

@Injectable()
export class RoleListEffect {
  loadRoleList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchRoleList),
      switchMap(({ filter }) =>
        this.roleService.getRoleList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedRoleList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedRoleList();
            }
          }),
          catchError(() => of(failedRoleList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateRoleListFilter),
      concatLatestFrom(() => this.store.select(selectRoleListFilter)),
      switchMap(([action, prevFilter]) =>
        of(fetchRoleList({ filter: { ...prevFilter, ...action.filter } }))
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly roleService: RoleService
  ) {}
}
